angular.module('app').directive('svgJsonLoader', function ($http) {
    return {
        restrict: 'A',
        scope: {
            svgPath: '@svgJsonLoader'
        },
        link: function (scope, element) {
            scope.$watch('svgPath', function (newPath) {
                if (!newPath) return;

                fetch(newPath)
                    .then(response => {
                        // Check for HTTP errors (404, 500, etc.)
                        if (!response.ok) {
                            throw new Error('Network response was not ok: ' + response.statusText);
                        }
                        return response.json(); // Explicitly parse JSON
                    })
                    .then(data => {
                        var viewBox = data['viewBox'] || ('0 0 ' + (data['width'] || 1024) + ' ' + (data['width'] || 1024));
                        var svgHtml = '<svg ' +
                            'viewBox="' + viewBox + '" ' +
                            (data['fontSize'] ? 'font-size="' + data['fontSize'] + '" ' : '') +
                            (data['color'] ? 'color="' + data['color'] + '" ' : '') +
                            'width="' + (data['size'] ?? 160) + '" ' +
                            'height="' + (data['size'] ?? 160) + '" ' +
                            'fill="currentColor" ' +
                            'xmlns="http://www.w3.org/2000/svg" aria-label="image" style="width: 100%; height: 100%" >';

                        angular.forEach(data.paths, function(p, i) {
                            if (p) {
                                svgHtml += '<path d="' + p + '" key="' + i + '"></path>';
                            }
                        });

                        svgHtml += '</svg>';
                        element.html(svgHtml);
                    })
                    .catch(err => {
                        console.error('CORS or Network Error:', err);
                    });
            });
        }
    };
});